<template>
    <dg-field-container :label_span="label_span" :field_span="field_span" :field_mark="field_mark"
         :field_validate_message="validateMessage">
        <template v-slot:label>
          <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
        </template>
        <template v-slot:field>
          <div v-if="editable">
            <el-date-picker :size="fieldSize" v-model="field_value" :value-format="valueFormat" type="date" placeholder="Pick a day" @blur="updateValue" :disabled="disabled">
            </el-date-picker>
            <slot name="field_note"></slot>
          </div>
          <div v-else>
            <dg-label-field :label="field_value" :translate="false"></dg-label-field>
          </div>
        </template>
    </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    valueFormat: {
      required: false,
      default: 'yyyy-MM-dd'
    }
  },
  data () {
    return {
      field_value: null
    }
  }
}
</script>
